import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ProductModel }      from './typings/product';
import { ProductsComponent } from './products.component';
import { ProductsService }   from './products.service';
import { TableService }      from '../table/table.service';

export const ProductsStates : Array<NgHybridStateDeclaration> = [
  {
    component: ProductsComponent,
    name     : 'app.products',
    resolve  : [
      {
        deps     : [ ProductsService, TableService ],
        resolveFn: ( productsService : ProductsService, tableService : TableService ) : Promise<Array<ProductModel>> => {
          const cache = tableService.getCacheForTable(productsService.tableCacheKey);

          return productsService.get({
              direction: cache.sorting.direction || 'asc',
              field    : cache.sorting.field     || 'item_code',
              offset   : 0,
              pageSize : cache.paging.pageSize   || 10
            }, {
              inactiveOnly: cache.filtering.inactiveOnly || false,
              value       : cache.filtering.value        || ''
            });
        },
        token: 'products'
      }
    ],
    url: '/products'
  }
];
